import {
  FETCH_ACCESS_APPROVAL_REQUESTS_REQUEST,
  FETCH_ACCESS_APPROVAL_REQUESTS_SUCCESS,
  FETCH_ACCESS_APPROVAL_REQUESTS_FAILURE,
  FETCH_USER_ACCESS_REQUEST_REQUEST,
  FETCH_USER_ACCESS_REQUEST_SUCCESS,
  FETCH_USER_ACCESS_REQUEST_FAILURE,
  APPROVE_ACCESS_REQUEST_REQUEST,
  APPROVE_ACCESS_REQUEST_SUCCESS,
  APPROVE_ACCESS_REQUEST_FAILURE,
  REJECT_ACCESS_REQUEST_REQUEST,
  REJECT_ACCESS_REQUEST_SUCCESS,
  REJECT_ACCESS_REQUEST_FAILURE,
} from "../actions/accessRequestActionTypes";

const initialState = {
  loading: false,
  requests: [],
  userRequest: null,
  error: null,
};

const accessApprovalRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    
    // === Admin: Fetch access requests ===
    case FETCH_ACCESS_APPROVAL_REQUESTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ACCESS_APPROVAL_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        requests: action.payload,
        error: null,
      };

    case FETCH_ACCESS_APPROVAL_REQUESTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // === Admin: Approve access requests ===
    case APPROVE_ACCESS_REQUEST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case APPROVE_ACCESS_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        // Option 1: just update state with the approved request response
        // Option 2 (better UX): filter out the approved request from the list
        requests: state.requests.filter(
          (req) => req.id !== action.payload.id
        ),
        error: null,
      };

    case APPROVE_ACCESS_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    // === Admin: Reject access requests ===
    case REJECT_ACCESS_REQUEST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case REJECT_ACCESS_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        requests: state.requests.filter(
          (req) => req.id !== action.payload.id
        ),
        error: null,
      };

    case REJECT_ACCESS_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // === User: Fetch their own request ===
    case FETCH_USER_ACCESS_REQUEST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_USER_ACCESS_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        userRequest: action.payload,
        error: null,
      };

    case FETCH_USER_ACCESS_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        userRequest: null,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default accessApprovalRequestsReducer;
